import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/AnalyticsDashboardEditableQuery$parameters';
import type { AnalyticsDashboardEditableQuery } from './__generated__/AnalyticsDashboardEditableQuery.graphql.ts';

type DashboardsAnalyticsQueries = {
	dashboardQuery: AnalyticsDashboardEditableQuery;
};

type DashboardsAnalyticsEntryPointComponent = EntryPointComponent<
	DashboardsAnalyticsQueries,
	{},
	{},
	{}
>;

export const dashboardsAnalyticsEntryPoint: EntryPoint<
	DashboardsAnalyticsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<DashboardsAnalyticsEntryPointComponent>(
		/* webpackChunkName: "dashboards-analytics-entrypoint" */ './DashboardsAnalyticsPage.tsx',
	),
	getPreloadProps: ({ tenantContext: { cloudId } }: EntryPointRouteParams) => {
		if (!expVal('platform_avp_dual_create_dashboards', 'isEnabled', false)) {
			return {};
		}
		return {
			queries: {
				dashboardQuery: {
					parameters,
					variables: {
						cloudId,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
